import React from "react";
import styled, { ThemeProvider, keyframes } from "styled-components";
import { DarkTheme } from "../Themes";
import LogoComponent from "../../SubComponents/LogoComponent/LogoComponent";
import PowerButton from "../../SubComponents/PowerButton/PowerButton";
import astronaute from "../../assets/Images/spaceman.png";
import BigTitle from "../../SubComponents/BigTitlte";
import SocialIcons from "../../SubComponents/SocialIcons";
import ParticleComponent from "../../SubComponents/ParticleComponent";
import BlogComponent from "../BlogComponent";
const Box = styled.div`
  background-color: black;
  width: 100vw;
  height: 100vh;
  position: relative;
  overflow: hidden;
`;
const float = keyframes`
0% { transform: translateY(-10px) }
50% { transform: translateY(15px) translateX(15px) }
100% { transform: translateY(-10px) }

`;
const Spaceman = styled.div`
  position: absolute;
  top: 10%;
  right: 5%;
  width: 20vw;
  z-index: 3;
  animation: ${float} 4s ease infinite;
  img {
    width: 100%;
    height: auto;
  }
`;
const Main = styled.div`
  border: 2px solid ${(props) => props.theme.text};
  color: ${(props) => props.theme.text};
  padding: 2rem;
  width: 50vw;
  height: 60vh;
  z-index: 3;
  line-height: 1.5;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: calc(0.6rem + 1vw);
  backdrop-filter: blur(4px);
  border-radius: 20px;
  position: absolute;
  left: calc(5rem + 5vw);
  top: 10rem;
  font-family: "Ubuntu Mono", monospace;
  font-style: italic;
`;
const AboutPage = () => {
  return (
    <ThemeProvider theme={DarkTheme}>
      <Spaceman>
        <img src={astronaute} alt="un astronautes dans les etoiles" />
      </Spaceman>
      <Main>
        Je suis un développeur frontend basé à Nouméa. J'aime créer des
        applications web accessibles et avec une bonne expérience utilisateur
        <br /> <br />
        J'aime relever de nouveaux défis, découvrir les dernières technologies
        et participer au développement de projets innovants.
        <br /> <br />
      </Main>
      <BigTitle text="ABOUT" top="10%" left="5%" />
      <Box>
        <LogoComponent theme="dark" />
        <SocialIcons theme="dark" />
        <PowerButton />
        <ParticleComponent theme="dark" />
      </Box>
    </ThemeProvider>
  );
};

export default AboutPage;
